import { DiscoveredAccount } from '../../utils';
import { FieldErrors } from '../../types';

export type LoginData = {
  captcha?: string | null;
  email: string;
  password?: string;
};

export type LoginFieldFlags = Record<keyof LoginData, boolean>;

export type LoginStatus = 'initial' | 'submitting' | 'success' | 'error';

export type LoginResult = {
  errors?: FieldErrors[];
};

export type LoginErrors = {
  captcha?: string;
  email?: string;
  error?: string;
  password?: string;
};

export type LoginOutput = {
  account?: DiscoveredAccount | undefined;
  errors?: LoginErrors;
  didRedirect: boolean;
  type?: LoginResultType;
};

export type UseLoginInput = {
  /**
   * Force email to be a certain value
   */
  email?: string;
  /**
   * Default email value, which can be edited
   */
  defaultEmail?: string;
  /**
   * Ignore auth_type cookie and force LoginForm to display
   */
  forceLoginDisplayForm?: boolean;
  /**
   * Url of page to redirect user to after successfully logging in
   */
  next?: string | undefined;
  /**
   * Routing callback to integrate with router. Will use window.href.location directly when not specified
   */
  routeTo?: (url: string) => void;

  /**
   * Should we render Google SSO?
   */
  googleSSOEnabled?: boolean;

  /**
   * Should we render Facebook SSO?
   */
  facebookSSOEnabled?: boolean;

  /**
   * Should we render Microsoft SSO?
   */
  microsoftSSOEnabled?: boolean;

  /**
   * Should we render Continue with SSO?
   */
  SAMLSSOEnabled?: boolean;
};

export enum LoginResultType {
  IS_2FA_REQUIRED = 'IS_2FA_REQUIRED',
  IS_BAD_CREDENTIALS = 'IS_BAD_CREDENTIALS',
  IS_CAPTCHA_REQUIRED = 'IS_CAPTCHA_REQUIRED',
  IS_EMAIL_VERIFICATION_REQUIRED = 'IS_EMAIL_VERIFICATION_REQUIRED',
  IS_LOCKED = 'IS_LOCKED',
  IS_MISSING_CSRF = 'IS_MISSING_CSRF',
  IS_PENDING_WORKSPACE_ACCESS = 'IS_PENDING_WORKSPACE_ACCESS',
  IS_SINGLE_SESSION = 'IS_SINGLE_SESSION',
  IS_VALID_LOGIN = 'IS_VALID_LOGIN',
  TRYING_TOO_OFTEN = 'TRYING_TOO_OFTEN',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}
